export default {
  SET_LOADING_WIDGETS: (state, { id, value }) => {
    state.loadingWidgets[id] = value;
  },
};
